<script>
import ParagraphCard from "../paragraph-card/ParagraphCard.vue";

export default {
  name: "NodeCustomerArea",
  components: {
    ParagraphCard
  }
};
</script>


<style lang="sass">

   .customer-area

       @import ../../common/styles/mixins

       .block-breadcrumb
           position: relative
           z-index: 1
           align-self: flex-start
           width: 100%
           padding-top: 6rem

           +media("<=975px")
                padding-top: 1rem

           &__content
               a, span
                   color: black

           &__cardresp
            +media("<=975px")
                display: flex

       .title
            font-size: 27px
            font-family: Montserrat, sans-serif
            font-weight: 700

            +media("<=975px")
                margin-bottom: 1rem
                line-height: 1.4

       &__form
           position: relative
           z-index: 1
           +container2
           width: 100%
           margin-top: auto
           margin-bottom: auto
           box-sizing: border-box
           text-align: center

           .text
               margin: 2rem auto
               line-height: 1.6

           form
               display: flex
               justify-content: space-between
               +media("<1000px")
                   display: block

               input
                   flex-grow: 1
                   flex-basis: calc(33% - 1rem)
                   height: 3rem
                   box-sizing: border-box
                   background: white
                   padding-left: 1rem
                   border: 0
                   +media("<1000px")
                       width: 100%
                       margin: 0 0 1rem 0!important

                   &:focus
                       outline: none

                   &::placeholder
                       color: $color-text
                       font-weight: 200

                   &:first-child
                       margin-right: 2rem

                   &:last-child
                       margin-left: 2rem

                   &[type=submit]
                       -webkit-appearance: none
                       background: $color-base
                       color: white
                       padding-left: 0

       &__downloads
           position: relative
           display: flex
           align-items: center
           justify-content: center
           z-index: 1
           margin-top: -1rem

       &__download
           margin: 0 0.5rem
           width: 10rem
           background: url(../../common/assets/download-appstore.png) no-repeat
           background-size: contain
           background-position: top center
           height: 4rem

           &--playstore
               background: url(../../common/assets/download-playstore.png) no-repeat
               background-size: contain

       &__links
           position: relative
           z-index: 1
           padding-bottom: 2rem
           text-align: center
           a
               color: white
               display: inline-block
               margin: 0 1rem
               font-size: 0.8rem
               +media("<=1000px")
                   display: block
                   margin-bottom: 1rem

       // Content

       &__content
          +container2
          position: inherit

          > h1.title
              font-size: 36px
              text-align: center
              +media("<=1024px")
                  font-size: 27px


          .title--2
              margin-bottom: 2.8rem
              &:before
                  left: 50%
                  transform: translateX(-50%)

          .title--7
              margin-top: 2.5rem
              margin-bottom: 2rem
              +media("<=1000px")
                  text-align: center

       &__card
            -webkit-box-shadow: 0px 0px 10px 6px rgba(0,0,0,0.1)
            -moz-box-shadow: 0px 0px 10px 6px rgba(0,0,0,0.1)
            box-shadow: 0px 0px 10px 6px rgba(0,0,0,0.1)
            margin: 2.8rem 2rem 4rem 2rem
            padding: 3rem
            display: flex
            border-top: 10px solid $color-base
            justify-content: space-around
            align-items: center
            transition: all .2s ease-in-out

            +media("<=975px")
                margin: 3rem 0
                padding: 2rem

            &:hover
                transform: scale(1.05)

            +media(">975px")
                > * + *
                    margin-left: 0.5rem

            &__content
                display: flex
                flex-direction: column
                justify-content: space-between
                line-height: 24px

                &__ctas
                    display: flex
                    align-items: center

                    +media("<=1128px")
                        flex-direction: column
                        margin-top: 1rem


                    > * + *
                        margin: 0 0 0 2rem
                        color: $color-blue

                        &:hover
                            color: darken($color-blue, 5)
                            text-decoration: underline

                        +media("<=1128px")
                            margin: 2rem 0 0 0

                    &--mobile
                        display: none

                        img
                            position: relative
                            max-width: 100px
                            max-height: 50px

                            +media("<=1128px")
                                max-width: 150px
                                max-height: 75px

                            +media("<=975px")
                                max-width: 120px
                                max-height: 60px

                        &:hover
                            transform: none


                        +media("<=1128px")
                            display: flex
                            > * + *
                                margin-left: 1rem

                ul
                    margin: 0

            &__access

                border-top: 10px solid $color-blue

                .button--blue
                    border-radius: 35px
                    -webkit-box-shadow: 5px 5px 8px 1px rgba(0, 0, 0, 0.1)
                    -moz-box-shadow: 5px 5px 8px 1px rgba(0, 0, 0, 0.1)
                    box-shadow: 5px 5px 8px 1px rgba(0, 0, 0, 0.1)
                    width: 12rem
                    padding: 1rem 0

                &__img
                    min-width: 270px
                    min-height: 270px
                    position: relative

                    +media("<=1128px")
                        display: none

                    img
                      max-width: 100%
                      height: auto
                      object-fit: cover

                    > *
                        position: absolute
                        width: 100%
                        display: flex
                        justify-content: space-evenly
                        bottom: 0
                        padding-bottom: 1rem

                    &--wrapper

                        img
                            position: relative
                            max-width: 100px
                            max-height: 50px

                            +media("<=1128px")
                                max-width: 150px
                                max-height: 75px

                            +media("<=975px")
                                max-width: 120px
                                max-height: 60px

                        &:hover
                            transform: none

            &__paiement
                img
                    width: 100%
                    max-width: 200px
                    height: auto

                +media("<=976px")
                    flex-direction: column
                    justify-content: center

                    img
                        margin-top: 2rem



       &__cardlist
            margin: 1.5rem 0 5rem
            display: flex
            flex-wrap: wrap

       +media(">975px")
            .title--section
                margin-left: 2rem

</style>
